import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CbreErrorHandler } from './handler/cbre-error-handler.service';
import { LoggerModuleConfig } from './logger-module.config';
import { LoggerConfigurationToken } from './logger/logger-config.model';
import { LoggerConfiguratorService } from './logger/logger-configurator.service';
import { CbreLoggerToken } from './logger/logger.model';
import { Logger } from './logger/logger.service';
import { TransporterToken } from './transporters/transporter.model';

// @dynamic
@NgModule({ declarations: [], exports: [], imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CbreLoggerModule {
  static forRoot(moduleConfig: LoggerModuleConfig): ModuleWithProviders<CbreLoggerModule> {
    /*
     * Return module decorator allowed only
     */
    return {
      ngModule: CbreLoggerModule,
      providers: [
        {
          // base logger configs
          provide: LoggerConfigurationToken,
          useValue: { level: moduleConfig.level, debugActions: moduleConfig.debugActions },
        },
        // set logger service
        moduleConfig.customLogger
          ? {
              provide: CbreLoggerToken,
              useClass: moduleConfig.customLogger.useClass,
              deps: moduleConfig.customLogger.deps || [LoggerConfigurationToken, TransporterToken],
            }
          : {
              provide: CbreLoggerToken,
              useClass: Logger,
            },
        // set error handler
        { provide: ErrorHandler, useClass: CbreErrorHandler },
        // Vanilla Logger,
        LoggerConfiguratorService,
      ],
    };
  }
}
